// Get the current date
const today = new Date();

// Calculate the date 21 days from today
const futureDate = new Date(today);
futureDate.setDate(today.getDate() + 21);

// Define the options for formatting in the Czech (cs-CZ) locale
const options = { 
  year: 'numeric', 
  month: 'long', 
  day: 'numeric',
  localeMatcher: 'best fit', 
  hour12: false 
};

// Format the future date as a string in the "D. Month YYYY" format (e.g., "17. listopad 2023")
const formattedDate = futureDate.toLocaleDateString(theme.strings.inventoryBackorderedLocale, options);

// Create the message with the calculated date
// Note: This message is also used in product-inventory.js on variant updates
const inventoryBackorderedMessage = `${theme.strings.inventoryBackorderedMessage} ${formattedDate}.`;

// Get all elements with the class 'product-available-from'
const messagesAvailableFrom = document.getElementsByClassName('product-available-from');

// Iterate through the elements and render the message in each of them
for (let i = 0; i < messagesAvailableFrom.length; i++) {
  messagesAvailableFrom[i].textContent = inventoryBackorderedMessage;
}

